import { render, staticRenderFns } from "./AddVPage.vue?vue&type=template&id=bc696c3e&scoped=true&"
import script from "./AddVPage.vue?vue&type=script&lang=js&"
export * from "./AddVPage.vue?vue&type=script&lang=js&"
import style0 from "./AddVPage.vue?vue&type=style&index=0&id=bc696c3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc696c3e",
  null
  
)

export default component.exports